import { FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { localeSelector } from '~src/domains/common/state/commonSelectors';
import { OffersTagProps } from '../types/components';
import { OfferLabelType } from '~src/domains/common/types/offers';
import * as styles from '~src/styles/domains/accept/components/OfferSelector.module.scss';

const OffersTag: FunctionComponent<OffersTagProps> = props => {
  const { t } = useTranslation();
  const locale = useSelector(localeSelector);
  const [language] = locale.split('-');
  const { type } = props;
  return (
    <div className={styles['offer-tag']}>
      <span className={styles['tag-text']}>
        {type === OfferLabelType.ZERO_APR
          ? t('accept:offerSelector.zeroAPRLabel')
          : t('accept:offerSelector.lowestPaymentLabel')}
      </span>
    </div>
  );
};

export default OffersTag;
